import React, { SyntheticEvent } from 'react';

import { Helmet } from 'react-helmet';
import { useLocation, useParams } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Container, Stack, Tab, Tabs } from '@mui/material';

import useAppNavigation from '~/hooks/useAppNavigation';

import TripPlannerChatTracePage from './TripPlannerChatTracePage';
import { tripPlannerChatTabs } from './tripPlannerChatTabs';

export default function TripPlannerChatPage() {
  const { push } = useAppNavigation();
  const location = useLocation();
  const { chatId } = useParams<{ chatId?: string }>();

  const currentTab = tripPlannerChatTabs.find((tab) => tab.path === location.pathname) ?? tripPlannerChatTabs[0];
  const tripsTabPath = tripPlannerChatTabs[0]?.path ?? '';

  const handleTabChange = (_event: SyntheticEvent, newValue: string) => {
    push({
      pathname: newValue,
      search: newValue === tripsTabPath ? location.search : '',
    });
  };
  const CurrentTabComponent = currentTab.component;
  const pageTitle = chatId ? 'Trace' : currentTab.title;

  return (
    <Container maxWidth="lg">
      <Helmet>
        <title>TripPlanner - Chat - {pageTitle}</title>
      </Helmet>

      {chatId ? (
        <TripPlannerChatTracePage
          renderHeader={(actions) => (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              flexWrap="wrap"
              gap={1}
              sx={{ py: 1.5 }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => push({ pathname: tripsTabPath, search: location.search })}
              >
                Back to Chats
              </Button>
              {actions}
            </Stack>
          )}
        />
      ) : (
        <>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
            <Tabs value={currentTab.path} onChange={handleTabChange}>
              {tripPlannerChatTabs.map((tab) => (
                <Tab key={tab.path} value={tab.path} label={tab.title} />
              ))}
            </Tabs>
          </Box>
          <CurrentTabComponent />
        </>
      )}
    </Container>
  );
}
